
import React from 'react'

interface EmptyResourceStateProps {
  title: string
  message: string
}

const EmptyResourceState = ({ title, message }: EmptyResourceStateProps) => (
  <div className="text-center py-8">
    <p className="text-gray-500 text-sm">{message}</p>
  </div>
)

export default EmptyResourceState
